module.exports = __webpack_public_path__ + "static/space.znzs-bc80dd19b51d246422d0e555819cb0b1.png";